export default __webpack_public_path__ + "23584fee075d84b88a7cc2c3564326ff.svg";